import { makeStyles } from "@mui/styles";
import { RosebudColorMap } from "../components/diagnosticAgent/rosebud/rosebudColorMap";

export const usePulse = makeStyles({
  "@keyframes pulse": {
    from: { backgroundColor: `${RosebudColorMap.DefaultLight}` },
    to: { backgroundColor: `${RosebudColorMap.White}` },
  },
  pulse: {
    animationName: "$pulse",
    animationDuration: "1000ms",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: "ease-in-out",
  },

  "@keyframes pulseStrength": {
    to: { backgroundColor: `${RosebudColorMap.White}` },
  },

  pulseStrength: {
    animationName: "$pulseStrength",
    animationDuration: "1000ms",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: "ease-in-out",
  },

  "@keyframes transparentPulse": {
    to: { backgroundColor: `${RosebudColorMap.uglyBlue4}` },
  },

  transparentPulse: {
    animationName: "$transparentPulse",
    animationDuration: "1000ms",
    animationIterationCount: "infinite",
    animationDirection: "alternate",
    animationTimingFunction: "ease-in-out",
  },

  withAnimation: ({ disabled }: { disabled: boolean }) => ({
    animationPlayState: disabled ? "paused" : "running",
  }),
});
